import React from "react";
import scooty from "../assets/section-image-7.png";

const WhyChooseSection = () => {
  return (
    <div id="why-choose" className="why-choose-comp">
      <div className="why-choose-header">
        <p className="why-choose-subtitle">Why Choose Right Lender ? </p>
      </div>
      <div className="why-choose-content">
        <div className="why-choose-left">
          <div className="sublist-column1">
            <div className="why-choose-block">
              <h4 className="highlight-color">“Say Good Bye”</h4>
              <p>- to the struggle and stress with <br />
                Right Lender, one application is all it takes.
              </p>
            </div>
            <div className="why-choose-block">
              <h4>“One Application. One Perfect Lender.”</h4>
              <p>
                “Apply once and get matched with your perfect lender — guiding you through
                your entire loan journey, for any loan product, from anywhere.”
              </p>
            </div>
          </div>
        </div>

        <div className="why-choose-right">
          <div className="why-choose-listrow">
            <div className="sublist-column1">
              <p>
                <span className="faq-questions-icon">●</span>
                Every day, lakhs of people apply for loans randomly. In
                today’s modern world, people have many dreams and goals, and
                Banks/NBFCs offer various types of loans to help fulfil them.
                However, when a Banks/NBFCs evaluates a loan application, it
                follows specific internal policies to decide whether to
                approve or reject the loan. <span className="highlight-color">A rejection doesn’t mean the
                borrower is ineligible everywhere — it simply means they
                didn’t meet that particular institution’s criteria</span>. The same
                borrower may reapply with the same bank after some time or try
                another bank where their profile may be a better fit. But
                here’s the problem — most customers don’t know where they’re
                truly eligible. As a result, many borrowers apply randomly
                with multiple banks/NBFCs, which can damage their credit score
                and create issues, especially in emergency situations.
              </p>
              <p>
                <span className="faq-questions-icon">●</span>
                To solve this, Right Lender was created by <span className="highlight-color highlight-rate">Perukkal 100
                Consultancy Private Limited</span>, associated with 65+ top banks and
                NBFCs. Backed by over 20 years of experience in handling all
                types of loans and credit cards, <span className="highlight-color">we built Right Lender to save
                the valuable time of both borrowers and banks</span>. We provide
                expert assistance in a wide range of financial products,
                including Personal Loans, Business Loans, Home Loans, Mortgage
                Loans, Doctor Loans, and NRI Loans. “Based on your
                application, the documents you submit, and conversations with
                our dedicated team, <span className="highlight-color">our experts thoroughly analyses each
                applicant’s documents</span> — including previous loan track (if
                any), bank statements, pay slips, ITRs, and all other relevant
                documents — as well as income, loan requirements, and credit
                history — and connect you with the most suitable Bank or NBFC.
              </p>
              <p>
                <span className="faq-questions-icon">●</span>
                We help customers access the lowest interest rates, minimal
                processing fees, and exclusive real-time offers from leading
                institutions. <span className="highlight-color">100% Paperless. 100% Peace of Mind - Login to
                Right Lender, fill all the mandatory fields, upload all the
                documents</span> — and relax. Our dedicated expert team will analyses
                your application thoroughly and update you shortly and connect
                you to the right Bank or NBFC Please note - <span className="highlight-color">The final decision
                on loan approval always rests with the Banks/NBFCs</span>. They will
                re-evaluate your application based on their internal criteria,
                your credit score, income, and requested loan amount Etc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseSection;